<template>
  <div class="wrapper">
    <van-cell-group>
      <div class="question">
        3.在您临床最近碰到的<span>10个疑似食物过敏</span>的患儿，<span>【诊断过程中】</span>需要替代配方时，大约有多少个采用了<span>氨基酸配方</span>替代喂养？（单选）</div>
      <div class="options">  
      <van-radio-group v-model="answerObj.value" direction="horizontal" @change="changeRadio">
        <van-radio v-for="item in options" :key="item" :name="item" style="margin-right:30px;">{{ item }}</van-radio>
      </van-radio-group>
    </div>
    <!-- <div class="options">  
      <el-slider v-model="result" show-input :max="10" :show-tooltip="false" @input="handleInput"></el-slider>
    </div> -->
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // result: '',
      options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      confirm: '',
      form: {
        total: 0
      },
      answerObj: {
        sort: '2',
        title: '如果您有100个疑似食物过敏的患儿，那么在诊断性食物回避需要使用替代配方时，以下不同类型配方使用的占比分别是多少？',
        remark: '',
        value: ''
        // answers: [
          // { sort: 1, seq: 'A 氨基酸配方AAF', percent: null },
          // { sort: 2, seq: 'B 深度水解配方EHF', percent: null },
          // { sort: 3, seq: 'C 部分水解配方PHF', percent: null},
          // { sort: 4, seq: 'D 不使用特医配方食品诊断', percent: null},
        // ],
      },
    };
  },
  created() {

  },
  methods: {
    changeRadio(e) {
      this.confirm = ''
      this.$emit('getAnswerSencond', e)
    },
    handleInput() {
      // this.form.total = this.answerObj.answers.reduce((pre, cur, index, arr) => {
      //   return pre + cur.percent;
      // }, 0);
      let total = 0;
      this.answerObj.answers.map(item => {
        if (item.sort !== 6) {
          total += item.percent === '' ? 0 : Number(item.percent);
        }
      })
      this.form.total = total;
      this.$emit('getAnswerSencond', this.answerObj.answers)
      this.confirm = ''
    },
  },
};
</script>

<style lang="less">
  .question {
    span {
        color: purple;
        font-weight: bold;
    }
  }
  .options {
      padding: 10px 0;
      font-size: 14px;
      // margin: 0 10px;
      // border-bottom: 1px solid #eee;
      // &:last-child {
      //   border-bottom: 1px solid #fff;
      // }
      .van-field {
        width: 130px;
        border-bottom: 1px solid #666;
        padding: 5px 0;
        .van-field__body {
          width: 100px;
        }
      }
  }
  .operation {
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      .total {
        line-height: 28px;
      }
      .tips {
        color: red;
        text-align: right;
        line-height: 28px;
      }
  }
</style>
